import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Input, Select } from '@material-ui/core';

class SimpleSelect extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, children, ...otherProps } =this.props;

        return (
            <Select
                input={<Input
                    classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput
                    }}
                    disableUnderline
                />}
                {...otherProps}
            >
                {children}
            </Select>
        );
    }
}

const style = theme => ({
    inputRoot: {
        ...theme.typography.body2
    },
    inputInput: {
        paddingLeft: 10
    }
});

export default withStyles(style)(SimpleSelect);